export function prepareBuffer(ec: any) {
    let buffer = ec?.getBuffer() ?? null;
    if (buffer !== null) {
        if (buffer.size > 0) buffer = buffer.get(ec.getPagePointer());
        else if (buffer.size === 0) buffer = [];
    }
    return structuredClone(buffer) ?? [];
}

// Flatten all loaded pages of the EC's results buffer into a single array in
// page order. Used by callers that paginate (e.g., the discover/analytics
// views, which sweep multiple pages so the visible record count isn't capped
// at PAGE_SIZE).
export function flattenAllPages(ec: any): any[] {
    const buffer = ec?.getBuffer() ?? null;
    if (!buffer || buffer.size === 0) return [];
    const out: any[] = [];
    const keys = Array.from(buffer.keys()).sort((a: any, b: any) => Number(a) - Number(b));
    for (const k of keys) {
        const page = buffer.get(k);
        if (Array.isArray(page)) {
            for (const record of page) out.push(record);
        }
    }
    return structuredClone(out);
}

export function getActiveRecord(ec: any) {
    let buffer = ec?.getBuffer() ?? null;
    if (buffer === null || buffer.size === 0) return null;
    return buffer.get(ec.getPagePointer())[ec.getRecordPointer()];
}